export default __webpack_public_path__ + "771b07e659c988f2b0f7eb737b28c8d7.jpg";